export default __webpack_public_path__ + "static/angela-bitmoji-8f8d17c8018a12dd2d83ea2794dc4cb6.png";